exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popup[data-v-0dea2bc3]{width:94%;height:92%;background-color:#f3f3f3;border:1px solid #d3d3d3;position:absolute;top:4%;left:3%;z-index:1;overflow-y:scroll}.popup__close[data-v-0dea2bc3]{width:15px;height:15px;position:absolute;top:8px;right:8px;z-index:1;cursor:pointer}.popup__close[data-v-0dea2bc3]:after,.popup__close[data-v-0dea2bc3]:before{content:\"\";width:16px;height:3px;background-color:#6b6b6b;position:absolute;top:6px;left:0}.popup__close[data-v-0dea2bc3]:before{-ms-transform:rotate(45deg);transform:rotate(45deg)}.popup__close[data-v-0dea2bc3]:after{-ms-transform:rotate(-45deg);transform:rotate(-45deg)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0dea2bc3","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/profile/modules/remote-edu/calendar/components/popup/CalendarPopup.vue
// module id = 1e90bf5312589a17427f
// module chunks = 7